import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import {
  AgActionIconButtonComponent
} from '@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component';
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { Note } from '@models/notes/note';
import { FileLabelComponent } from "@shared/components/commons/file-label/file-label.component";

@Component({
  selector: 'app-note-list-element',
  standalone: true,
  imports: [
    DatePipe,
    AgActionIconButtonComponent,
    HasRoleDirective,
    FileLabelComponent
  ],
  templateUrl: 'note-list-element.component.html',
  styleUrl: 'note-list-element.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteListElementComponent {
  @Input() note!: Note;
  @Input() disabled = false;

  @Output() editNote = new EventEmitter<void>();
  @Output() deleteNote = new EventEmitter<void>();
  @Output() downloadFile = new EventEmitter<string>();
  @Output() deleteFile = new EventEmitter<string>();

  readonly authService = inject(AuthService);

  onEditNote(): void {
    this.editNote.emit();
  }

  onDeleteNote(): void {
    this.deleteNote.emit();
  }

  onDownloadFile(filename: string): void {
    if(this.canEdit) {
      this.downloadFile.emit(filename);
    }
  }

  onDeleteFile(filename: string): void {
    if(this.canEdit) {
      this.deleteFile.emit(filename);
    }
  }

  get canEdit(): boolean {
    const allowedRoles = ['Admin', 'Manager', 'Preparer'];
    return this.authService.hasRole(allowedRoles);
  }
}
